// TIPMIN1 (docs/build-briefs/TIPMIN1-card-minimum-charge.md). Pure constants, no imports, so the tablet bundle can share them with
// the server. Stripe refuses a card charge below its minimum for the currency (https://docs.stripe.com/currencies, "Minimum and
// maximum charge amounts": $0.50 USD).

/** Stripe's minimum charge in USD cents. */
export const CARD_MINIMUM_CHARGE_CENTS = 50;

export const CARD_MINIMUM_CHARGE_MESSAGE =
  "Card payments must be at least $0.50. Take this tip in cash or choose a larger tip.";

/** True when a card charge of this size would be refused for being too small: more than zero, under the minimum. Zero is not
 * covered: a $0.00 card charge is closed through the no-tip close (ZEROPAY1) and never reaches the provider. */
export function isBelowCardMinimum(amountCents: number): boolean {
  return amountCents > 0 && amountCents < CARD_MINIMUM_CHARGE_CENTS;
}
